import { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Grid,
  Typography,
  Paper,
  Snackbar,
  CircularProgress,
  Link,
  useTheme,
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';

import authService from '@shared/services/authService';
import { HOTELS, LOGIN } from '@shared/helpers/routes';
import { onUserLogin } from '../../redux/actions';
import { setUser } from '@shared/helpers/auth';

import { sxStyled } from './styles';

const token =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwia2V5IjoibW90b3JzdGF0aWMiLCJpYXQiOjE1MTYyMzkwMjJ9.XsgrtoA4DtpZZcnxvdddonTZtMgashaOwKdaf5FS90o';

export default () => {
  const { email } = useParams();
  const dispatch = useDispatch();
  const { site_logos } = useSelector(store => store.pageConfiguration);
  const history = useHistory();

  const theme = useTheme();

  const sxStyle = sxStyled(theme);

  const [openAlert, setOpenAlert] = useState({
    message: '',
    isVisible: false,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateLogin = async () => {
      authService
        .loginMotor(atob(email), token)
        .then(response => {
          setUser(response);
          dispatch(onUserLogin(response));
          history.push(HOTELS);
        })
        .catch(({ response }) => {
          handleOpenAlert(response.data.message);
          setIsLoading(false);
          setTimeout(() => {
            history.push(LOGIN);
          }, 1000);
        });
    };
    validateLogin();
  }, []);

  const Alert = props => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  };

  const handleOpenAlert = message => {
    setOpenAlert({
      message,
      isVisible: true,
    });
  };

  const handleCloseAlert = () => {
    setOpenAlert({
      message: '',
      isVisible: false,
    });
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={sxStyle.root}
    >
      <Paper elevation={1} sx={sxStyle.container}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item container direction="column" xs={12} md={6} spacing={2}>
            <Grid item sx={sxStyle.infoContainer}>
              <Typography variant="h6" align="center">
                Validando credenciales...
              </Typography>
              {isLoading ? (
                <CircularProgress size={50} sx={sxStyle.progress} />
              ) : null}
            </Grid>
          </Grid>
          <Grid
            item
            container
            alignItems="center"
            justifyContent="center"
            xs={6}
            sx={sxStyle.imageContainer}
          >
            <Grid item>
              <Link href="/">
                <img
                  src={site_logos.principal}
                  style={{
                    width: '100%',
                  }}
                />
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Snackbar
        open={openAlert.isVisible}
        autoHideDuration={2000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseAlert} severity="error">
          {openAlert.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};
